import { useQuery } from 'react-query'
export function useJabTrackerData({ contentApi }: { contentApi: string }) {
    //checks env by URL, sets api

    const jabTrackerData = useQuery('jab-tracker-data', async () => {
        const api = `${contentApi}/assets/jab-tracker/data.json`

        const response = await fetch(api)

        if (!response.ok) {
            throw new Error('Network response was not ok')
        }

        const res = await response.json()

        return res
    })

    return jabTrackerData
}
